import React, { useEffect, useState } from "react";
import { Eye, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const KEY = "findo_preview_region";
const EVENT = "findloop:preview-region-changed";

export function readPreviewRegion() {
  try {
    // Optional URL override (?preview=afrique|europe) — shareable & persisted.
    const q = new URLSearchParams(window.location.search).get("preview");
    if (q === "europe" || q === "afrique") {
      try { localStorage.setItem(KEY, q); } catch { /* ignore */ }
      return q;
    }
    const v = localStorage.getItem(KEY);
    return v === "europe" || v === "afrique" ? v : null;
  } catch {
    return null;
  }
}
export function writePreviewRegion(region) {
  if (region === "europe" || region === "afrique") {
    localStorage.setItem(KEY, region);
  } else {
    localStorage.removeItem(KEY);
  }
  window.dispatchEvent(new Event(EVENT));
}
export function clearPreviewRegion() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
}

const LABELS = { europe: "Europe", afrique: "hc.africa" };

export default function PreviewRegionBanner() {
  const { t } = useLang();
  const [region, setRegion] = useState(readPreviewRegion());

  useEffect(() => {
    const sync = () => setRegion(readPreviewRegion());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  if (!region) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-findo-navy text-white" data-testid="preview-region-banner">
      <div className="max-w-6xl mx-auto px-4 py-1.5 flex items-center justify-center gap-3 text-xs sm:text-sm">
        <span className="inline-flex items-center gap-2 font-semibold">
          <Eye size={14} className="flex-shrink-0" />
          {t("hc.previewMode")} {t(LABELS[region])}
        </span>
        <button
          onClick={() => clearPreviewRegion()}
          className="inline-flex items-center gap-1 rounded-full bg-white/15 hover:bg-white/25 px-2.5 py-0.5 font-semibold transition-colors"
          data-testid="preview-region-quit-btn">
          <X size={12} /> {t("hc.exit")}
        </button>
      </div>
    </div>
  );
}
